import * as moment from 'moment';
import GuestListActions from '../../actions/GuestListActions';
import { actions as ActionTypes } from '../../constants/GuestListConstants';
import RoutingActions from '../../actions/RoutingActions';
import NotificationActions from '../../actions/NotificationActions';
import UserStore from '../../stores/UserStore';
import GuestListStore from '../../stores/GuestListStore';
import UserActions from '../../actions/UserActions';
import AppDispatcher from '../../utils/AppDispatcher';

class Select extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            validDPHCredentials : UserStore.getState().validDPHCredentials,
        };

        this.onGuestListStoreChange = this.onGuestListStoreChange.bind(this);
        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.selectGuestForPos = this.selectGuestForPos.bind(this);
    }

    componentDidMount() {
        GuestListStore.addChangeListener(this.onGuestListStoreChange);
        UserStore.addChangeListener(this.onUserStoreChange);
    }

    componentWillUnmount() {
        GuestListStore.removeChangeListener(this.onGuestListStoreChange);
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onGuestListStoreChange() {
        var self = this;

        if (!this.props.selected || !this.state.loading)
            return;

        var guestList   = GuestListStore.getState().guestList;
        var guest       = this.props.selected;
        var match       = false;

        for (var i=0; i<guestList.length; i++) {
            if (guestList[i].Guest_id === guest.Guest_id)
                match = true;
        }

        if (!match) {
            setTimeout(() => {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : 'Guest is no longer signed in'
                });
            }, 10);

            this.props.clearSelected();
            return;
        }

        this.setState({ loading : false }, () => {
            for (var i=0; i<guestList.length; i++) {
                if (guest.Guest_id === guestList[i].Guest_id) {
                    guest = guestList[i];
                }
            }

            if (guest.Register.length > 0 && UserStore.getState().selectedRegister.TerminalName !== guest.Register) {
                Promise.resolve().then(() => { 
                    NotificationActions.addNotification({
                        type : 'alert',
                        body : 'Guest is already assigned to '+guest.Register
                    });
                });
            } else {
                Promise.resolve().then(() => { 
                    GuestListActions.selectGuestForPos(guest);
                    RoutingActions.updateRoute('pos/'+guest.Guest_id);
                });
            }
        });
    }

    onUserStoreChange() {
        this.setState({ validDPHCredentials : UserStore.getState().validDPHCredentials });
    }

    selectGuestForPos() {
        const selectedLocation = UserStore.getState().selectedLocation;
        let register = UserStore.getState().selectedRegister;
        let guest = this.props.guest;

        if (!register) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Please select a register first'
            });
            return;
        }

        if (selectedLocation.Attestation && guest.Attestation.toLowerCase() === 'no') {
            NotificationActions.error('Patient Has not completed the Attestation Document. You cannot Proceed.')
            return;
        }

        let attestationExpirationDate = moment(this.props.guest.AttestationExpirationDate);
        if (selectedLocation.Attestation && (moment().isAfter(attestationExpirationDate, 'day') || moment().isSame(attestationExpirationDate, 'day'))) {
            NotificationActions.error('Patient Attestation Document has expired. You cannot Proceed.')
            return;
        }

        if (selectedLocation.CanUseMassDPHIntegration && !this.state.validDPHCredentials  && guest.PatientType !== 'Recreational' && selectedLocation.RequireValidAllotmentCredentials) {
            NotificationActions.error('Your DPH Credentials are invalid! Go to settings and update to continue.', true);
            return;
        }

        if (!!selectedLocation.RequireDoctorForCheckIn && !(parseInt(this.props.guest.doctor) > 0)) {
            NotificationActions.error('Patient does not have a doctor on record.');
            return;
        }

        if (selectedLocation.RequireValidDL
            && UserActions.isDriversLicenseExpired(this.props.selected)) {

            NotificationActions.error('Patient\'s Driver\'s License has expired.');
            return;
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(this.props.selected)) {

            NotificationActions.error('Patient\'s MMJ License has expired.');
            return;
        }

        const minorAge = UserActions.getMinorAge(selectedLocation, this.props.selected.IsMedical)
        if (selectedLocation.BlockMinorsFromCheckInFF && UserActions.checkMinorStatus(this.props.selected, minorAge)) {

            NotificationActions.error(`Patient is under the age of ${minorAge}. You cannot proceed`);
            return;
        }

        this.setState({ loading : true }, () => {
            if(!UserStore.getState().selectedLocation.UseSmartCheckin){
                GuestListActions.loadGuestList();
            }else{
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GUEST_LIST_LOADED,
                    data: GuestListStore.getState().guestList
                });
            }
        });
    }

    render() {
        var guest    = this.props.guest;
        var selectedLocation = UserStore.getState().selectedLocation;
        var lsp = this.props.lsp;
        var attestationExpirationDate = moment(this.props.guest.AttestationExpirationDate);

        var disabled =
            !UserStore.getState().selectedRegister ? true : false ||
            (guest && guest.Attestation.toLowerCase() === 'no' && selectedLocation.Attestation
                || (moment().isAfter(attestationExpirationDate, 'day') || moment().isSame(attestationExpirationDate, 'day'))) ||
            (selectedLocation.CanUseMassDPHIntegration && !this.state.validDPHCredentials && guest.PatientType !== 'Recreational' && selectedLocation.RequireValidAllotmentCredentials)

        return (
            <li>
                <div
                    className={'btn-green '+(disabled ? 'btn-green__disabled' : '')}
                    onClick={this.selectGuestForPos}>

                    SELECT
                </div>
            </li>
        );
    }
}

export default Select;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/Select.react.jsx